(function() {
  function initSliders() {
    const sliders = document.querySelectorAll('.custom-product-slider-inner:not([data-initialized="true"])');
    
    sliders.forEach(slider => {
      const desktopSlider = slider.dataset.desktopSlider === 'true';
      const mobileSlider = slider.dataset.mobileSlider === 'true';
      const slidesToShowDesktop = parseFloat(slider.dataset.slidesToShowDesktop) || 4;
      const slidesToShowMobile = parseFloat(slider.dataset.slidesToShowMobile) || 2;
      
      if (typeof Swiper !== 'undefined') {
        const swiperInstance = new Swiper(slider, {
          slidesPerView: slidesToShowMobile,
          spaceBetween: 15,
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            750: {
              slidesPerView: slidesToShowDesktop,
              enabled: desktopSlider,
              spaceBetween: 20
            }
          },
          enabled: mobileSlider || window.innerWidth >= 750,
          watchOverflow: true,
          loop: false
        });
        slider.setAttribute('data-initialized', 'true');
      }
    });
  }

  function initSwatches() {
    document.querySelectorAll('.custom-product-card:not([data-swatches-initialized="true"])').forEach(card => {
      const mainImg = card.querySelector('.main-image');
      const swatches = card.querySelectorAll('.swatch-item');
      
      swatches.forEach(swatch => {
        swatch.addEventListener('click', function(e) {
          e.preventDefault();
          const newImgUrl = this.dataset.imageUrl;
          if (newImgUrl && mainImg) {
            mainImg.src = newImgUrl;
            mainImg.srcset = newImgUrl;
            
            swatches.forEach(s => s.classList.remove('active'));
            this.classList.add('active');
            
            const variantUrl = this.dataset.variantUrl;
            if (variantUrl) {
                card.querySelectorAll('a').forEach(a => a.href = variantUrl);
            }
          }
        });
      });
      card.setAttribute('data-swatches-initialized', 'true');
    });
  }

  function setupObservers() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          initSliders();
          initSwatches();
        }
      });
    });

    document.querySelectorAll('product-recommendations').forEach(el => {
      observer.observe(el, { childList: true });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initSliders();
    initSwatches();
    setupObservers();
  });

  document.addEventListener('shopify:section:load', () => {
    initSliders();
    initSwatches();
    setupObservers();
  });
})();

/* ------------------------------------------------------------------
   AUREN quick add (Impulse-stijl) voor .custom-product-card
   Knop op de afbeelding -> maatpaneel -> toevoegen via cart drawer.
------------------------------------------------------------------- */
(function () {
  if (window.__aurenQuickAdd) return;
  window.__aurenQuickAdd = true;

  function getData(card) {
    var el = card.querySelector('.cpc-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function activeVariantId(card) {
    var sw = card.querySelector('.swatch-item.active');
    var url = sw && sw.dataset.variantUrl;
    var m = url && url.match(/variant=(\d+)/);
    return m ? parseInt(m[1], 10) : null;
  }

  function setMsg(card, text) {
    var msg = card.querySelector('.cpc-quick-panel__msg');
    if (msg) msg.textContent = text || '';
  }

  function closePanel(card) {
    if (!card) return;
    var panel = card.querySelector('.cpc-quick-panel');
    if (panel) panel.hidden = true;
    card.classList.remove('quick-open');
  }

  function addToCart(card, variantId, trigger) {
    if (trigger) { trigger.classList.add('is-loading'); trigger.disabled = true; }
    setMsg(card, '');
    var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { setMsg(card, res.description || 'Sorry, this size is unavailable.'); return; }
        closePanel(card);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ id: variantId, sections: res.sections });
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { setMsg(card, 'Something went wrong. Please try again.'); })
      .finally(function () {
        if (trigger) { trigger.classList.remove('is-loading'); trigger.disabled = false; }
      });
  }

  function openPanel(card, data) {
    var sizeIdx = data.sizeIndex;
    var variants = data.variants;
    var base = null;
    var activeId = activeVariantId(card);
    if (activeId) base = variants.find(function (v) { return v.id === activeId; });
    if (!base) base = variants.find(function (v) { return v.available; }) || variants[0];

    var matches = variants.filter(function (v) {
      return v.options.every(function (val, i) { return i === sizeIdx || val === base.options[i]; });
    });

    var wrap = card.querySelector('.cpc-quick-panel__sizes');
    wrap.innerHTML = '';
    matches.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cpc-size';
      b.textContent = String(v.options[sizeIdx]).split('/')[0].trim();
      if (!v.available) { b.disabled = true; b.classList.add('is-unavailable'); }
      b.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(card, v.id, b);
      });
      wrap.appendChild(b);
    });

    setMsg(card, '');
    card.querySelector('.cpc-quick-panel').hidden = false;
    card.classList.add('quick-open');
  }

  document.addEventListener('click', function (e) {
    var close = e.target.closest('.cpc-quick-panel__close');
    if (close) { e.preventDefault(); closePanel(close.closest('.custom-product-card')); return; }

    var btn = e.target.closest('.cpc-quick-btn');
    if (!btn) {
      document.querySelectorAll('.custom-product-card.quick-open').forEach(function (c) {
        if (!c.contains(e.target)) closePanel(c);
      });
      return;
    }
    e.preventDefault();
    var card = btn.closest('.custom-product-card');
    var data = getData(card);
    if (!data || !data.variants.length) return;

    var available = data.variants.filter(function (v) { return v.available; });
    if (data.sizeIndex < 0 || data.variants.length === 1) {
      var id = activeVariantId(card);
      var chosen = data.variants.find(function (v) { return v.id === id && v.available; }) || available[0];
      if (chosen) addToCart(card, chosen.id, btn);
      return;
    }
    if (card.classList.contains('quick-open')) { closePanel(card); return; }
    openPanel(card, data);
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.custom-product-card.quick-open').forEach(closePanel);
  });
})();
